import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from 'src/app/shared/pipes.module';
import { Sms } from 'src/app/core/graphql/generated/gen-types';

@Component({
	selector: 'app-wa-message',
	standalone: true,
	imports: [MatButtonModule, MatIconModule, TranslateModule, PipeModule],
	templateUrl: './wa-message.component.html',
	styleUrl: './wa-message.component.scss',
})
export class WaMessageComponent {
	@Input() message: Sms;

	waBaseUrl = environment.waBucketUrl;

	getImageUrl(): string | null {
		return `${this.waBaseUrl}/${this.message?.wa?.image?.gcp_media_path}`;
	}
	getVideoUrl(): string | null {
		return `${this.waBaseUrl}/${this.message?.wa?.video?.gcp_media_path}`;
	}
	getMessageType(): string {
		if (this.message?.waLink) return 'waLink';

		if (this.message?.text) return 'text';
		if (this.message?.wa?.image) return 'waImageIn';
		if (this.message?.wa?.video) return 'waVideoIn';
		if (this.message?.waImage) return 'waImageOut';
		if (this.message?.wa?.location) return 'waLocation';
		return 'default';
	}

	openImageInNewWindow() {
		const imageUrl = this.getImageUrl();
		if (imageUrl) {
			window.open(imageUrl, '_blank');
		}
	}

	getGoogleMapsUrl(): string {
		const lat = this.message?.wa?.location?.degreesLatitude;
		const lng = this.message?.wa?.location?.degreesLongitude;
		return `https://maps.google.com/?q=${lat},${lng}`;
	}

	openLocationInMaps() {
		const mapsUrl = this.getGoogleMapsUrl();
		if (mapsUrl) {
			window.open(mapsUrl, '_blank');
		}
	}
}
